// ── Admin → Region: what the picked country's pack brings (package cpacklegal) ─────────────────────
// The country pack (server services/countryPacks.ts) may carry statutory rules — the tax-ID check, the
// local legal forms and titles, the amount in words, the VAT rate. Only Thailand has them; for any other
// country the admin sees, before saving, that those features fall back (nothing is invented for it).
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function StatutoryPackNote({ pack }: { pack?: any }) {
  const { t } = useTranslation();
  if (!pack) return null;
  const parts: string[] = [];
  if (pack.taxId) parts.push(t('cpl_taxid', { label: pack.taxId.label, digits: pack.taxId.digits }));
  if (pack.legalSuffixes) parts.push(t('cpl_forms'));
  if (pack.honorifics) parts.push(t('cpl_titles'));
  if (pack.amountInWords) parts.push(t('cpl_words'));
  if (typeof pack.vatRate === 'number') parts.push(t('cpl_vat', { rate: pack.vatRate }));
  return (
    <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginTop: 4 }}>
      {parts.length ? `${t('cpl_rules')}: ${parts.join(' · ')}` : t('cpl_none', { name: pack.name || pack.country })}
    </div>
  );
}
